import React, { useEffect, useState, useRef } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { getApiURL } from '../../constants';
import { IColors, IPersonItem } from '../../interfaces/Conference';
import { ITrainingItemCourse } from '../../interfaces/Calendar';
import { calendarApi } from '../../services/calendar.service';
import ButtonTemplate from '@ui/Button/Button';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY } from '../../constants';
import { saveAs } from 'file-saver';
import moment from 'moment';
import 'moment/locale/cs';
import {
    CloseButton,
    Footer,
    Header,
    Icon,
    Modal,
    ModalContent,
    WrapperModal,
    Input,
    InputSection,
    Error,
    Info,
    InputSectionDate,
} from './TrainingCertificate.elements';

interface ModalProps {
    onClose: () => void;
    course?: ITrainingItemCourse;
    userKey?: String;
}

const TrainingCertificateClerkDataTemplate: FC<ModalProps> = ({ onClose, course, userKey }) => {
    const { t } = useTranslations();

    const [isLoading, setIsLoading] = useState(false);
    const [hasFirstNameError, setHasFirstNameError] = useState(false);
    const [hasBirthDayError, setHasBirthDayError] = useState(false);
    const firstNameInputRef = useRef(null);
    const [birthDay, setBirthDay] = useState('');

    const handlePDFclerk = (key: string) => {

        setHasFirstNameError(false);
        setHasBirthDayError(false);

        if (birthDay === '') {
            setHasBirthDayError(true);
            return;
        }

        if (firstNameInputRef?.current?.value === '') {
            setHasFirstNameError(true);
            return;
        }



        const data = {
            birthPlace: firstNameInputRef?.current?.value,
            birthDate: birthDay
        }

        setIsLoading(true);

        calendarApi
            .getTrainingCertificateClerk(key, Cookies.get(ACCESS_TOKEN_KEY), true, data)
            .then(({ data }) => {
                saveAs(data, `certifikat_cislo_${course._key}-${userKey}.pdf`);
                setIsLoading(false);
                onClose();
            })
            .catch();
    };


    const handleChange = (e: any) => {
        if (e._d) {
            setBirthDay(moment(e._d).format('D. M. YYYY'));
        }
    };

    return (
        <WrapperModal>
            <Modal>
                <ModalContent>
                    <CloseButton onClick={onClose}>
                        <Icon name={Icons.Xmark} />
                    </CloseButton>
                    <Header>

                        <InputSectionDate>
                            <Datetime
                                // @ts-ignore
                                inputProps={{ placeholder: 'Datum narození*' }}
                                locale='cs'
                                timeFormat={false}
                                dateFormat='D.M.YYYY'
                                onChange={(e) => handleChange(e)}
                            />
                            {hasBirthDayError && <Error>{t('material.birthday.error')}</Error>}
                        </InputSectionDate>

                        <InputSection>
                            <Input
                                className={hasFirstNameError ? 'error' : ''}
                                ref={firstNameInputRef}
                                placeholder={`${t('material.birthplace')}*`}
                            />
                            {hasFirstNameError && <Error>{t('material.birthplace.error')}</Error>}
                        </InputSection>


                        <Info>{t('material.personalData.info')}</Info>


                    </Header>

                    <Footer>
                        <ButtonTemplate
                            isLoading={isLoading}
                            onClick={() => handlePDFclerk(course._key)}
                            disabled={isLoading}
                            marginTop={25}
                            text={t('material.download.certificate')}
                        />
                    </Footer>
                </ModalContent>
            </Modal>
        </WrapperModal>
    );
};

export default TrainingCertificateClerkDataTemplate;
